import React, { createContext, useContext, useState, useEffect } from "react";

interface ApiContextType {
  apiKey: string | null;
  setApiKey: (key: string) => void;
  removeApiKey: () => void;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const useApi = () => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error("useApi must be used within an ApiProvider");
  }
  return context;
};

export const ApiProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [apiKey, setApiKeyState] = useState<string | null>(null);

  useEffect(() => {
    // Load API key from localStorage on mount
    const savedApiKey = localStorage.getItem("gemini_api_key");
    if (savedApiKey) {
      setApiKeyState(savedApiKey);
    }
  }, []);

  const setApiKey = (key: string) => {
    localStorage.setItem("gemini_api_key", key);
    setApiKeyState(key);
  };

  const removeApiKey = () => {
    localStorage.removeItem("gemini_api_key");
    setApiKeyState(null);
  };

  return (
    <ApiContext.Provider value={{ apiKey, setApiKey, removeApiKey }}>
      {children}
    </ApiContext.Provider>
  );
};
